/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import apiClient from '../apiClient';
import { ReportsQueryParams, ReportsListDto, DownloadReportsQueryParams } from './reportsClient.typings';
import { cutEmptyParamsIncludingArrays, makeArrayFromCommaSeparatedString } from '../../../utils/utils';
import moment from 'moment';
import { RequestToCreateExcelDto } from '../downloadings/downloadingsClient.typings';

function getAggregates(params: ReportsQueryParams, isByDay: boolean): Promise<ReportsListDto> {
    const { search_type, search_text, dateFrom, dateTo } = params;
    delete params.search_text;
    delete params.search_type;

    const queryParams = {
        ...params,
        [search_type]: makeArrayFromCommaSeparatedString(search_text, true),
        dateFrom: isByDay ? moment(dateFrom) : dateFrom,
        dateTo: isByDay ? moment(dateTo) : dateTo,
    };

    if (isByDay)
        return apiClient.post<ReportsListDto>('1.0.0/reports/cashBoxDay', cutEmptyParamsIncludingArrays(queryParams));

    return apiClient.post<ReportsListDto>('1.0.0/reports/cashBox', cutEmptyParamsIncludingArrays(queryParams));
}

function downloadAggregatesDataReportFile(
    params: DownloadReportsQueryParams,
    isByDay: boolean,
): Promise<RequestToCreateExcelDto> {
    const { search_type, search_text, dateFrom, dateTo } = params;

    delete params.search_text;
    delete params.search_type;

    const body = {
        ...params,
        [search_type]: makeArrayFromCommaSeparatedString(search_text, true),
        dateFrom: isByDay ? moment(dateFrom).format('YYYY-MM-DD') : dateFrom,
        dateTo: isByDay ? moment(dateTo).format('YYYY-MM-DD') : dateTo,
    };

    if (isByDay) return apiClient.post('1.0.0/reports/cashBoxDay/excel', cutEmptyParamsIncludingArrays(body));
    else return apiClient.post('1.0.0/reports/cashBox/excel', cutEmptyParamsIncludingArrays(body));
}

export const reportsClient = {
    getAggregates,
    downloadAggregatesDataReportFile,
};
